import React from 'react';
import Search from '../assets/images/search-illustration.svg';

export default () => {
  return <img src={Search} alt="No Search Results" />;
};
